import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import EditIcon from '@mui/icons-material/Edit';
import TableCellTooltip from '../../../common/TableCellTooltip';
import { focusElemnt, navigation3 } from '../../../common/helper';
import * as mdt from '../../../common/modaltypes';
import { columnDefs as originalColumnDefs } from './BrnchMasterConstant';
import moment from 'moment/moment';

const BranchMasterTable = ({ setSelEditBranch, updateModal, showModal, modalType, tableData, loginData }) => {
    const [reportData, setReportData] = useState(tableData);
    const [selModalRow, setSelModalRow] = useState('');
    const [searchData, setSearchData] = useState({
        BranchID: "",
        BranchCode: "",
        BranchName: "",
        CityName: "",
        StateName: "",
        BranchType: "",
        GSTN: "",
        CargoGSTNO: "",
        BranchManagerName: "",
        ContactNo1: "",
    });

    // Memoize column definitions
    const columnDefs = useMemo(() => originalColumnDefs, []);

    // Sort and filter table data
    const filterAndSortData = useCallback(() => {
        const filteredData = tableData.filter(val =>
            Object.keys(searchData).every(key =>
                searchData[key] === "" ||
                (val[key]?.toString().toLowerCase().includes(searchData[key].toString().toLowerCase()))
            )
        );
        return filteredData.sort((a, b) => a.BranchID - b.BranchID);
    }, [tableData, searchData]);

    useEffect(() => {
        setReportData(filterAndSortData());
    }, [filterAndSortData]);

    // Handle search data changes with debouncing
    const handleSearchData = (event, field) => {
        setSearchData(prevData => ({ ...prevData, [field]: event.target.value }));
    };

    const keyboardNavigation = (event, prevId, nextId) => {
        if (event.key === 'Escape') {
            focusElemnt(prevId);
        }
        if (event.key === 'Enter') {
            focusElemnt(nextId);
        }
    };

    return (
        <TableContainer className='scrollBlue' component={Paper} sx={{ maxHeight: '70vh', marginBottom: "5px" }}>
            <Table stickyHeader size="small" aria-label="a dense table">
                <TableHead sx={{ position: 'sticky', top: 0, zIndex: 2 }}>
                    <TableRow>
                        {columnDefs.map((col, index) => (
                            <TableCell key={`TH-${index}`} sx={{ ...col.headerSx, backgroundColor: '#DAEDFE', padding: '8px 6px !important', minHeight: '36px !important', fontSize: '12px', fontWeight: '700', color: '#444' }}>
                                {col.headerName}
                            </TableCell>
                        ))}
                    </TableRow>
                    <TableRow sx={{ '& .MuiTableCell-root': { padding: '6px !important' } }}>
                        {columnDefs.map((col, index) => (
                            col.showfilter ? (
                                <TableCell key={`FTH-${index}`}>
                                    <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                        <input
                                            id={`Contains-${index}`}
                                            className="field"
                                            value={searchData[col.field]}
                                            name="cancelSearchInput"
                                            style={{ width: '100%' }}
                                            placeholder="Contains"
                                            onChange={(e) => handleSearchData(e, col.field)}
                                            onKeyDown={(e) => keyboardNavigation(e, index === 1 ? "createBtn" : `Contains-${index - 1}`, index === 11 ? reportData.length > 0 ? `Edit-0` : 'status' : `Contains-${index + 1}`)}
                                        />
                                        <FilterAltIcon sx={{ paddingRight: '0px !important', color: '#aaa !important' }} />
                                    </div>
                                </TableCell>
                            ) : <TableCell key={`FTH-${index}`}></TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody sx={{ '& .MuiTableCell-root': { padding: '6px !important' } }}>
                    {reportData.map((val, index) => (
                        <TableRow key={`DR-${index}`} sx={{ backgroundColor: selModalRow === index && showModal && mdt.editBranchMaster === modalType ? '#FFFDAF99' : '' }}>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{index + 1}</TableCell>
                            <TableCellTooltip title={loginData?.strCompanyName} data={loginData?.strCompanyName} placement={'bottom-start'} textAlign={"left"} maxWidth={'160px'} />
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.BranchID}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.BranchCode}</TableCell>
                            <TableCellTooltip title={val.BranchName} data={val.BranchName} placement={'bottom-start'} textAlign={"left"} maxWidth={'15%'} />
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.CityName}</TableCell>
                            <TableCellTooltip title={val.StateName} data={val.StateName} placement={'bottom-start'} textAlign={"left"} maxWidth={'90px'} />
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.BranchType}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.GSTN}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.CargoGSTNO}</TableCell>
                            <TableCellTooltip title={val.BranchManagerName} data={val.BranchManagerName} placement={'bottom-start'} textAlign={"left"} maxWidth={'100px'} />
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.ContactNo1}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.CreatedDatetime === "" ? '' : moment(val.CreatedDatetime).format('DD MMM YYYY,HH:mm')}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.ModifiedDatetime === "" ? '' : moment(val.ModifiedDatetime).format('DD MMM YYYY,HH:mm')}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.ModifiedByUser}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}>
                                <Checkbox checked={val.IsActive === 1} sx={{ padding: 0 }} />
                            </TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', cursor: "pointer" }}>
                                <span
                                    id={`Edit-${index}`} tabIndex={0}
                                    style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold' }}
                                    onClick={() => {
                                        setSelModalRow(index);
                                        setSelEditBranch(val.BranchID);
                                        updateModal(true, mdt.editBranchMaster);
                                    }}
                                    onKeyDown={(e) => {
                                        navigation3(e, reportData.length - 1 === index ? 'status' : `Edit-${index + 1}`, index === 0 ? 'Contains-11' : `Edit-${index - 1}`, () => { });
                                    }}
                                >
                                    <EditIcon sx={{ marginRight: '3px' }} />
                                    Edit
                                </span>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default BranchMasterTable;